export const DUPLICATE_CLIENTS_REQUEST = 'DUPLICATE_CLIENTS_REQUEST';
export const DUPLICATE_CLIENTS_SUCCESS = 'DUPLICATE_CLIENTS_SUCCESS';
export const DUPLICATE_CLIENTS_FAILURE = 'DUPLICATE_CLIENTS_FAILURE';
export const MERGE_CLIENT_REQUEST = 'MERGE_CLIENT_REQUEST';
export const MERGE_CLIENT_SUCCESS = 'MERGE_CLIENT_SUCCESS';
export const MERGE_CLIENT_FAILURE = 'MERGE_CLIENT_FAILURE';

export const defaultState = {
  clientList: [],
  errorLoading: false,
  loadingClientsData: false,
};
